window.anvil.component('form', el => {
    const customButton = el.querySelector('.component-button');
    const formId = customButton.dataset.formId;

    // Custom spinner
    const spinner = el.querySelector('.js-spinner').cloneNode(true);
    spinner.classList.remove('skeleton');
    el.querySelector('.js-spinner').remove();

    // Submit the form after clicking the custom button
    customButton.addEventListener('click', () => {
        const form = el.querySelector(`form[data-formid="${formId}"]`);

        if (form) {
            form.submit();
            const event  = new CustomEvent('submit', {detail: null, bubbles: true});
            form.dispatchEvent(event);
        }
    });

    // Show spinner at the end of the form
    el.addEventListener('submit', ({target}) => {
       target.appendChild(spinner);
    });

    // Remove the custom button after the form is successfully sent
    jQuery(document).on('gform_confirmation_loaded', function (event, gravityId) {
        if (formId == gravityId) customButton.remove();
    });
});
